import React, { useContext } from 'react';
import { CountingCirclesRecord } from 'api/api.types';
import classNames from 'classnames';
import ApiContext from 'api/ApiContext';
import { PagesectionSubsection } from '@ktag/styleguide/dist/react';
import MapSwitch, { MuniTab } from 'lib/MapSwitch/MapSwitch';
import ProportionalMap from './ProportionalMap';
import ProportionalMapDetails from './ProportionalMapDetails';
import ProportionalMapSelect from './ProportionalMapSelect';

interface Props {
  map: string;
  records: CountingCirclesRecord[];
  hoveredMapElement: CountingCirclesRecord | null;
  selectedMapElement: CountingCirclesRecord | null;
  isLoadingMap: boolean;
  setSelectedMapElement: (element: CountingCirclesRecord | null) => void;
  render: (
    municipality: CountingCirclesRecord,
    prevDistrict?: CountingCirclesRecord,
  ) => JSX.Element;
  addMapSwitch?: boolean;
  selectedMuniTab: MuniTab;
  setSelectedMuniTab: (tab: MuniTab) => void;
}

const ProportionalMapWrapper = ({
  map,
  records,
  hoveredMapElement,
  selectedMapElement,
  isLoadingMap,
  setSelectedMapElement,
  render,
  addMapSwitch,
  selectedMuniTab,
  setSelectedMuniTab,
}: Props) => {
  const { language } = useContext(ApiContext);

  return (
    <div
      className={classNames('proportionalmap__wrapper', {
        'proportionalmap__wrapper--with-switch': addMapSwitch,
      })}
    >
      <div className="map__search">
        <ProportionalMapSelect
          records={records}
          selectedMapElement={selectedMapElement}
          setSelectedMapElement={setSelectedMapElement}
        />
        <MapSwitch selectedTab={selectedMuniTab} setSelectedTab={setSelectedMuniTab} />
      </div>
      <PagesectionSubsection type="broad">
        <div
          className={classNames('proportionalmap__contents', {
            'proportionalmap__contents--selected': selectedMapElement,
          })}
        >
          <ProportionalMap
            map={map}
            hoveredElement={hoveredMapElement}
            selectedElement={selectedMapElement}
            isLoading={isLoadingMap}
            records={records}
          />
          {selectedMapElement && (
            <ProportionalMapDetails
              municipality={selectedMapElement?.name[language]}
              inProgress={!selectedMapElement.finished}
            >
              {selectedMapElement.finished && render(selectedMapElement)}
            </ProportionalMapDetails>
          )}
        </div>
      </PagesectionSubsection>
    </div>
  );
};

export default ProportionalMapWrapper;
